import React from 'react';
import '../App.css';
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem
} from 'cdbreact';
import { Image } from 'react-bootstrap';
import logo from '../assets/logo_blanc.png';
import { NavLink } from 'react-router-dom';

const Sidebar = (props) => {
  const email = localStorage.getItem('Login');
  return (
    <div
      style={{ display: 'flex', height: '100vh',  position:'fixed' }}
    >
      <CDBSidebar 
        textColor="#fff" 
        backgroundColor="#076129"
        style={{
          width: '70px',          // Slim width
          borderTopRightRadius: '20px',
          borderBottomRightRadius: '20px',
          alignItems: 'center',   // Center content horizontally
          paddingTop: '170px'
        }}
        >
        {/* <CDBSidebarHeader>
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: 'inherit'}}
          >
            ASDT MANAGER
          </a>
        </CDBSidebarHeader> */}

        <CDBSidebarContent className="sidebar-content">
          <CDBSidebarMenu>
            <NavLink exact to="/" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="home">Home</CDBSidebarMenuItem>
            </NavLink>
            <NavLink exact to="/detector" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="broadcast-tower">Device</CDBSidebarMenuItem>
            </NavLink>
            <NavLink exact to="/alerts" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="exclamation-triangle">Alerts</CDBSidebarMenuItem>
            </NavLink>
            <NavLink exact to="/config" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="cogs">Configuration</CDBSidebarMenuItem>
            </NavLink>
            <NavLink exact to="/register" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="pencil-alt">Register</CDBSidebarMenuItem>
            </NavLink>
            {
              email === "admin@asdt.eu" ? <NavLink exact to="/users" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="user">Users</CDBSidebarMenuItem>
            </NavLink> : <NavLink to='/users'></NavLink>
            }
            {
              email === "ldi@asdt.eu" ? <NavLink exact to="/users" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="user">Users</CDBSidebarMenuItem>
            </NavLink> : <NavLink to='/users'></NavLink>
            }
            
          </CDBSidebarMenu>

        </CDBSidebarContent>

        <CDBSidebarFooter style={{ textAlign: 'center' }}>
          <div
            className="sidebar-btn-wrapper"
            style={{
              padding: '20px 5px',
            }}
          >
            <Image src={logo} width='180px' style={{ textAlign: 'center'}} />
          </div>
          
        </CDBSidebarFooter>
      </CDBSidebar>
    </div>
  );
};

export default Sidebar;